import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';
import Navbarp from '../Components/CommonComponents/Navbarp';
import SideNav from '../Components/CommonComponents/SideNav';
import { TextField, Grid } from '@mui/material';
import { useState,useEffect } from 'react';
import PagesNumber from '../Components/CommonComponents/PagesNumber';
import {BASE_URL} from '../Config/Config';
import { getLogin, getToken, logout } from '../features/Loginuser';
import { setplans } from '../features/Plan';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Form from 'react-bootstrap/Form';
import '.././css/List.css'
import '.././css/Card.css'
import '.././css/Loader.css'
import { formatdate } from '../Common/Dateformat';
import Loader from '../Components/CommonComponents/Loader';
import GetCustomerDairyRateList from '../Components/List/GetCustomerDairyRateList';
import Calendar from '../Components/CommonComponents/Calendar';

function CustomerDairyRateList() {
  const dispatch=useDispatch();
  const [startdate, setstartdate] =useState("");
  const[enddate,setenddate]=useState("");
  const [list, setList] = useState([]);
  const login = useSelector(getLogin);
  const token=useSelector(getToken);
  const [lastPage, setLastPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading,setLoading]=useState(true)
  const[totalratelist,setTotalRateList]=useState(0) 
  const [count, setCount] = useState(0);
  const [sortingby,setSortingBy]=useState(1)
  let params = useParams();
  
  const [searchBy,setSearchBy]=useState({
      "records":100,
      "startdate":"",
      "enddate":"",
        "id":params.id,    
    });
  useEffect(() => {
    let searchstr=searchstring(searchBy);
      fetch(BASE_URL+"customerratelists?page="+currentPage+"&"+searchstr, {
          method: "GET",
          headers: {
            //'X-XSRF-TOKEN': 'XSRF-TOKEN)',
                'Accept': 'application/json',
              'Content-Type': 'application/json',
              "Authorization": "Bearer "+token,
          }

          })
          
          .then((response) => {
            if (response.status===401){
              dispatch(logout());
            }else{
              return response.json()
            }
          })
          //Then with the data from the response in JSON...
          .then((data) => {
              setLoading(false);
              setList(data.result.data);
              setLastPage(data.result.last_page);
              setCurrentPage(data.result.current_page);
              setTotalRateList(data.totalratelist);
              setCount(data.count)
              
          })
  }, [currentPage,searchBy])
    function setpage(value){
      if (value >=1&& value<=lastPage){
          setCurrentPage(value)
      }
    }
    function searchParam(value,key){
     setSearchBy({...searchBy,[key]:value})
    }
    const searchstring=(searchBy)=>{
      let passdata={...searchBy};
      if(searchBy.startdate!=null && searchBy.enddate!=null){
        passdata.startdate=searchBy.startdate;
        passdata.enddate=searchBy.enddate;
      }
      var queryString = Object.keys(passdata).map(key => key + '=' + passdata[key]).join('&');
      return queryString
    }
    var arr=[...list]
    function sort(type,key){
      if(sortingby==1){
        //code for sorting on server 
        setSearchBy({...searchBy,"sortby":key,"sorttype":type});
      }else{
      // Code for sorting in browser 
        if (type=="asc"){
         for (let i=0;i<arr.length;i++){
             for (let j=0;j<=i;j++){
                 if (arr[i][key] < arr[j][key]) {
                     var x = arr[i];
                     arr[i] =arr[j];
                     arr[j] = x;
                 }
             }
         }
      }
      if (type=="desc"){
         for (let i=0;i<arr.length;i++){
             for (let j=0;j<=i;j++){
                 if (arr[i][key] >arr[j][key]) {
                     var x = arr[i];
                     arr[i] =arr[j];
                     arr[j] = x;
                 }
             }
         }
      }
     setList(arr);
      }
     }
    if(login==null||login==false){
    return  <Navigate to="/" replace={true} />
    }
     return (
       <>
         <div className="container-fluid ps-0">
           <div className="row">
             <div>
             <Navbarp />
             </div>
             <div className='position-absolute'>
                <div className='mt-1'>
                <Grid container className='justify-content-between' >
                  <div className='d-md-flex width_100'>
                        <Grid item  className='me-3 mt-2'>
                          <Card className='record' >
                            <CardContent>
                              <Typography variant="h6" gutterBottom>
                                 Total Dairy Rate List 
                              </Typography>
                               <Typography variant="h6" gutterBottom>
                                 {count}
                              </Typography>
                            </CardContent>   
                          </Card>
                        </Grid>
                        <Grid item  className='me-3 mt-2'>
                          <Card className='total'>
                            <CardContent>
                              <Typography variant="h6" gutterBottom>
                                 Dairy Name
                              </Typography>
                              <Typography variant="h6" gutterBottom>
                                 {params.name}
                              </Typography>
                            </CardContent>   
                          </Card>
                        </Grid>
                  </div>      
                  <div>
                  <Calendar
                     searchBy={searchBy} 
                     setSearchBy={setSearchBy}
                     setSortingBy={setSortingBy}
                     lastPage={lastPage} 
                     currentPage={currentPage} 
                     setpage={setpage} 
                    />
                  </div>
                </Grid>
                  {loading?
                   <Loader/>:
                  <div>
                  <GetCustomerDairyRateList data={list} searchParam={searchParam} sort={sort}/>
                  </div>
                  }
                  
                </div>       
             </div>
           </div>
         </div>
       </>
     );
}

export default CustomerDairyRateList